import React from "react";
import { TableCell, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { TrackRow } from "frontend/src/ui/track-row";
import { useTimetableRelationToPlayer } from "frontend/src/features/show-entities-relations-to-player";
import { pause } from "frontend/src/features/control-audio";
import { playTodayTimetableAttempted } from "frontend/src/features/play-todays-timetable";
var useStyles = makeStyles(function (theme) { return ({
    cell: {
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        borderBottom: "1px solid rgba(255, 255, 255, 0.14)",
        backgroundColor: theme.palette.type === "dark"
            ? "rgba(12, 18, 28, 0.18)"
            : "rgba(255, 255, 255, 0.18)",
        transition: "background-color 160ms ease",
        "$row:hover &": {
            backgroundColor: theme.palette.type === "dark"
                ? "rgba(255, 255, 255, 0.10)"
                : "rgba(255, 255, 255, 0.34)",
        },
    },
    row: {},
    title: {
        fontWeight: 500,
    },
}); });
export var MobileTimetableRow = function (_a) {
    var id = _a.id, title = _a.title;
    var classes = useStyles();
    var _b = useTimetableRelationToPlayer(id), isPlaying = _b.isPlaying, isLoading = _b.isLoading, isSelectedForPlayer = _b.isSelectedForPlayer;
    var play = function () { return playTodayTimetableAttempted({ id: id, title: title }); };
    return (React.createElement(TrackRow, { className: classes.row, isSelectedForPlayer: isSelectedForPlayer },
        React.createElement(TableCell, { className: classes.cell },
            React.createElement(AudioControlButton, { isLoading: isLoading, onPause: pause, onPlay: play, isPlaying: isPlaying })),
        React.createElement(TableCell, { className: classes.cell },
            React.createElement(Typography, { className: classes.title }, title))));
};
export var DesktopTimetableRow = function (_a) {
    var id = _a.id, title = _a.title;
    var classes = useStyles();
    var _b = useTimetableRelationToPlayer(id), isPlaying = _b.isPlaying, isLoading = _b.isLoading, isSelectedForPlayer = _b.isSelectedForPlayer;
    var play = function () { return playTodayTimetableAttempted({ id: id, title: title }); };
    return (React.createElement(TrackRow, { className: classes.row, isSelectedForPlayer: isSelectedForPlayer },
        React.createElement(TableCell, { className: classes.cell, width: "5%" },
            React.createElement(AudioControlButton, { isLoading: isLoading, onPause: pause, onPlay: play, isPlaying: isPlaying })),
        React.createElement(TableCell, { className: classes.cell },
            React.createElement(Typography, { className: classes.title }, title))));
};
